import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const sections = [
  {
    title: '1. 事業者情報',
    content: `本ウェブサイトおよびサービスは、sanctuary（サンクチュアリ、埼玉県川口市）が運営しています。個人情報の取り扱いに関するお問い合わせは、下記連絡先までご連絡ください。\n\nメール：info@sanctuary-kawaguchi.com`,
  },
  {
    title: '2. 収集する個人情報',
    content: `当サロンでは、以下の情報をお客様からご提供いただく場合があります。\n\n・お名前\n・メールアドレス\n・お問い合わせ・ご相談内容\n・セッション中にお話しいただいた内容`,
  },
  {
    title: '3. 個人情報の利用目的',
    content: `収集した個人情報は、以下の目的のためにのみ使用します。\n\n・セッションのご予約・日程調整のご連絡\n・お問い合わせへの回答\n・サービスの提供およびご案内\n・法令に基づく対応`,
  },
  {
    title: '4. 第三者への提供',
    content: `お客様の個人情報は、以下の場合を除き、第三者に提供・開示・共有することはありません。\n\n・お客様ご本人の同意がある場合\n・法令に基づき開示が必要な場合\n・人の生命・身体・財産の保護のために必要な場合`,
  },
  {
    title: '5. 個人情報の管理・保護',
    content: `お客様の個人情報を厳重に管理し、不正アクセス・漏洩・滅失・毀損の防止に努めます。また、利用目的に必要な期間を超えた個人情報は、適切な方法で廃棄いたします。`,
  },
  {
    title: '6. Cookieの使用について',
    content: `当ウェブサイトでは、サービス向上のためCookieを使用する場合があります。Cookieによって個人を特定できる情報を収集することはありません。ブラウザの設定によりCookieを無効にすることも可能です。`,
  },
  {
    title: '7. 個人情報の開示・訂正・削除',
    content: `お客様ご自身の個人情報について、開示・訂正・削除をご希望の場合は、下記連絡先までお申し出ください。ご本人確認の上、合理的な期間内に対応いたします。\n\nメール：info@sanctuary-kawaguchi.com`,
  },
  {
    title: '8. プライバシーポリシーの変更',
    content: `本ポリシーの内容は、法令の変更やサービス内容の変更に伴い、予告なく変更する場合があります。変更後のポリシーは、本ページに掲載した時点から効力を生じます。`,
  },
  {
    title: '9. お問い合わせ',
    content: `個人情報の取り扱いに関するご質問・ご相談は、以下までお気軽にご連絡ください。\n\nsanctuary（サンクチュアリ）\nメール：info@sanctuary-kawaguchi.com`,
  },
];

export default function PrivacyPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] font-sans">
      {/* Header */}
      <div className="w-full py-6 px-6 border-b" style={{ borderColor: '#EDE7DC', backgroundColor: 'white' }}>
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <Link to="/" className="cursor-pointer font-serif text-[#3A3530] text-xl italic tracking-widest hover:opacity-70 transition-opacity">
            sanctuary
          </Link>
          <Link to="/" className="cursor-pointer font-sans text-[#8FA68B] text-xs tracking-wider hover:opacity-70 transition-opacity flex items-center gap-1">
            <i className="ri-arrow-left-line text-sm" />
            トップへ戻る
          </Link>
        </div>
      </div>

      <main className="max-w-2xl mx-auto px-6 py-16">
        <p className="font-sans text-[#8FA68B] text-xs tracking-[0.4em] mb-4 uppercase">privacy</p>
        <h1 className="font-serif text-3xl text-[#3A3530] mb-4">プライバシーポリシー</h1>
        <p className="font-sans text-[#8B8480] text-xs mb-12">
          sanctuary（以下「当サロン」）は、お客様の個人情報の保護を重要な責務と考え、以下の方針に基づき適切に取り扱います。
        </p>

        <div className="space-y-10">
          {sections.map((sec, i) => (
            <div key={i}>
              <h2 className="font-serif text-[#3A3530] text-base mb-3">{sec.title}</h2>
              <p className="font-sans text-[#6B6460] text-sm leading-loose whitespace-pre-line">
                {sec.content}
              </p>
            </div>
          ))}
        </div>

        <div
          className="mt-12 p-5 rounded-lg"
          style={{ backgroundColor: 'rgba(143,166,139,0.08)', border: '1px solid rgba(143,166,139,0.2)' }}
        >
          <p className="font-sans text-[#8B8480] text-xs leading-relaxed">
            ※ sanctuary は医療機関ではありません。提供するサービスは医療行為ではなく、医師による診断・治療の代替となるものではありません。
          </p>
        </div>

        <p className="font-sans text-[#8B8480] text-xs mt-8">最終更新日：2026年3月23日</p>
      </main>

      <div className="py-8 text-center" style={{ backgroundColor: '#EDE7DC' }}>
        <p className="font-sans text-[#B0A89E] text-xs">© 2026 sanctuary. All rights reserved.</p>
      </div>
    </div>
  );
}
